// extracted by mini-css-extract-plugin
export default {"container":"BottomInfo_container__e1PNZ","text":"BottomInfo_text__3uEAd"};